import { render, staticRenderFns } from "./EtapaSelo.vue?vue&type=template&id=b53c7b52&scoped=true&"
import script from "./EtapaSelo.vue?vue&type=script&lang=js&"
export * from "./EtapaSelo.vue?vue&type=script&lang=js&"
import style0 from "./EtapaSelo.vue?vue&type=style&index=0&id=b53c7b52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53c7b52",
  null
  
)

export default component.exports